import React,{ FC, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import { Checkbox, Empty, InfiniteScroll, Mask, SafeArea, Toast } from "antd-mobile"
import { ClockCircleOutline, CloseOutline} from 'antd-mobile-icons'
import 'antd-mobile/es/components/dialog'
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { UninvoiceType } from "~src/service/bill/bill";
import { getUninvoiceList } from "~src/service/bill";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import classNames from "classnames";
import { useWXPath } from "~src/hooks/useWXPath";
import useInApp, { isInApp } from "~src/hooks/useInApp";
import { bill_rectangle_3078, bill_rectangle_3079, green_living_empty, mio_copy_color_icon } from "~src/constants/network";
import useQuery from "~src/hooks/useQuery";
import { MioStorage } from "~src/constants/storage";

interface BillItemProps {
  item: UninvoiceType
  onChange: (row:UninvoiceType,checked: boolean) => void
}

const BillItem:FC<BillItemProps> = ({item, onChange}) => {
  const onClickCopy = () => {
    var aux = document.createElement("input"); 
    aux.setAttribute("value", item.orderNo); 
    document.body.appendChild(aux); 
    aux.select();
    document.execCommand("copy"); 
    document.body.removeChild(aux);
    Toast.show({
      content: '复制成功',
      afterClose: () => {
        console.log('after')
      },
    })
  }
  return <div className={styles.item}>
    <div className={styles["item-title"]}>
      <Checkbox
        value='1'
        defaultChecked={item.checked}
        onChange={onChange.bind(this,item)}
        icon={(checked: boolean, indeterminate: boolean) =>{
          return checked? <i className={classNames("iconfont icon-select2", styles.checkCircle) } /> : <i className={classNames(styles["card-header-lable-icon"],"iconfont icon-select1") } />
        }}
        className={styles["item-title-name"]}
        >{item.title}</Checkbox>
    </div>
    <div className={styles["item-pre"]}>¥{item.totalAmount}</div>
    <div className={classNames(styles["item-row"], styles["item-mar"])}>
      <div className={styles["item-row-label"]}>订单号</div>
      <div className={classNames(styles["item-row-value"], styles["item-row-copy"])} onClick={onClickCopy}>
        <div>{item.orderNo}</div>
        <img className={styles.mio_copy_color_icon} src={mio_copy_color_icon}  alt=""></img>
      </div>
    </div>
    <div className={styles["item-row"]}>
      <div className={styles["item-row-label"]}>交易时间</div>
      <div className={styles["item-row-value"]}>{item.orderTime}</div>
    </div>
  </div>
}

const BillHome: FC = () => {
  useDocumentTitle('申请发票')
  const searchQuery = useQuery()
  const biz = localStorage.getItem(MioStorage.BIZ)|| searchQuery("biz") || "charge"
  const navigate = useNavigate()
  const wxPath = useWXPath()
  const inApp = useInApp()
  const [list, setList] = useState<UninvoiceType[]>([])
  const [hasMore, setHasMore] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const [show, setShow] = useState<boolean>(true)
  const [isAll, setIsAll] = useState<boolean>(false)
  const [bizName, setBizName] = useState<string>(biz)
  const guid = localStorage.getItem("mio-guid")
  const conf = useRef({
    page: 0,
    pageSize: 10,
    bizName: bizName,
    status: 0
  })
  const onChange = useCallback( (row: UninvoiceType, checked:boolean) =>{
    setList(() => updateDataWithNewItem(list, row, checked))
  }, [list])
  const loadMore = async() =>{
    conf.current.page += 1
    conf.current.bizName = bizName
    const {list, hasNext} = await getUninvoiceList(conf.current)
    setList(val => [...val, ...list.map(ele => {
      ele.checked = isAll
      return ele
    })])
    setHasMore(hasNext)
  }
  const doSearch = () => {
    conf.current.page = 0
    setList([])
    setHasMore(true)
    loadMore()
  }

  useEffect(() => {
    doSearch()
  }, [bizName])
  const onderNum = ():number =>{
    return  list.filter(obj => obj.checked === true).length;
  }
  const onderIds = ():string =>{
    let sum = [];
    for (const obj of list) {
      if (obj.checked === true) {
        sum.push(obj.orderNo);
      }
    }
    return sum.toString()
  }
  const onderMoner = ():number =>{
    let sum = 0;
    for (const obj of list) {
      if (obj.checked === true) {
        sum += (obj.totalAmount);
      }
    }
    return sum
  }
  const updateDataWithNewItem =(data:UninvoiceType[], newItem:UninvoiceType, checked:boolean)=> {
    const index = data.findIndex((element) => element.orderNo === newItem.orderNo);
    if (index>=0) {
      data[index].checked = checked
    }
    return JSON.parse(JSON.stringify(data))
  }
  const onClickSubMit = () => {

    setVisible(false)
    if (isInApp()) {
      window.location.href =`https://wj.qq.com/s2/12736223/4a76?openid=${guid}|${isAll?1:0}|${onderIds()}|${bizName}`
      return
    }
    wxPath("redirectTo", `/pages/scene/charge/bill/index?openid=${guid}|${isAll?1:0}|${onderIds()}|${bizName}`)
  }
  const onChangeAll = (checkd:boolean) =>{
    setIsAll(checkd)
    setList(() => {
      const lt =JSON.parse(JSON.stringify(list.map((item) => {
        item.checked = checkd;
        return item
      })))
      return lt
    })
  }
  const onOpenMask = () => {
    if (onderNum() > 0) {
      setVisible(true)
    }
  }
  return <div className={styles.bill}>
    {
      !inApp && <div className={styles.hotel}>
      <div className={styles["hotel-title"]}>
        <div className={classNames(styles["hotel-title-text"], bizName === "hotel" && styles["hotel-title-active"])} 
        onClick={() => {
          setBizName("hotel")
          localStorage.setItem(MioStorage.BIZ, "hotel")
        }}>绿色住订单</div>
        <div className={classNames(styles["hotel-title-text"], bizName === "charge" && styles["hotel-title-active"])}
        onClick={() => {
          setBizName("charge")
          localStorage.setItem(MioStorage.BIZ, "charge")
        }}>充电订单</div>
      </div>
      <div className={styles["hotel-bg"]}>
        <img className={styles["hotel-bg-img"]}  src={bizName === "hotel"? bill_rectangle_3079: bill_rectangle_3078} alt="" />
      </div>
    </div>
    } 
    <div className={styles.box} >
    <div className={styles["bill-header"]}>
          <div className={styles["bill-header-item"]} onClick={() => {
            navigate(`/bill/rule?biz=${bizName}`)
          }}>
            <ClockCircleOutline className={styles["bill-header-item-icon"]} fontSize={16} />
            <span>开票规则</span>
          </div>
          <div className={styles["bill-header-item"]} onClick={() => {
            navigate(`/bill/history?biz=${bizName}`)
          }}>
            <ClockCircleOutline  className={styles["bill-header-item-icon"]}/>
            <span>开票历史</span>
          </div>
        </div>
        {
          show&&<div className={styles["bill-tips"]}>
            <div className={styles["bill-tips-text"]}> *发票申请成功后将在15个工作日发送到收件邮箱，可在开票历史中查看开票进度 </div>
            <CloseOutline fontSize={19} onClick={() => {setShow(false)}}/>
          </div>
        }

      {list.length > 0 ? (
          <>
            <div className={styles["bill-body"]}>
              <div className={styles["bill-body-title"]}>可供开发票的订单（近3个月）</div>
              {list.map((item, index) => (
                <div className={styles["bill-body-item"]} key={item.orderNo+item.checked}>
                <BillItem item={item} onChange={onChange}/>
              </div>
              ))}
            </div>
            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
          </>
        ) : <Empty imageStyle={{width: "240px"}} image={green_living_empty} />
        }
    </div>
    {
      (onderNum()> 0) &&  <div className={styles["bill-footer"]}>
      <div className={styles["bill-footer-content"]}>
        <div className={styles["bill-footer-content-left"]}>
        <Checkbox defaultChecked={isAll}
        icon={(checked: boolean, indeterminate: boolean) =>{
          return checked? <i className={classNames("iconfont icon-select2", styles.checkCircle) } /> : <i className={classNames(styles["card-header-lable-icon"],"iconfont icon-select1") } />
        }}
        onChange={onChangeAll}>
          <div className={styles["bill-footer-content-left-check"]}>全选</div>
        </Checkbox>
        <div className={styles["bill-footer-content-left-info"]}>
          <div>{onderNum()}个订单 </div>
          <div>
            <span>总金额：¥</span>
            <span className={styles["bill-footer-content-left-info-unit"]}>{onderMoner().toFixed(2)}</span>
          </div>
        </div>
        </div>
        <div className={classNames(styles["bill-footer-content-right"], !(onderNum()> 0) && styles["bill-footer-content-unsel"])}
        onClick={onOpenMask}>申请发票</div>
      </div>
      <SafeArea position='bottom' />
    </div>
    }
   
    <Mask visible={visible} onMaskClick={() => setVisible(false)}>
        <div className={styles.overlayContent}>
            <div className={styles["overlayContent-title"]}>确认申请发票？</div>
            <div className={styles["overlayContent-unit"]}>发票总金额：¥{onderMoner().toFixed(2)}</div>
            <div className={styles["overlayContent-tips"]}>发票可能将根据收款类型拆分为多张</div>
            <div className={styles["overlayContent-footer"]}>
              <div onClick={() =>setVisible(false)}>取消</div>
              <div className={styles["overlayContent-footer-finish"]} onClick={onClickSubMit}>确定</div>
            </div>
        </div>
    </Mask>
  </div>
}
export default BillHome